/* ─────────────────────────────────────────────────────────────────────────
   Valves page — ONLY solenoid-valve devices, rendered with the existing
   SolenoidBox card (self-fetches open/closed + online).
   ──────────────────────────────────────────────────────────────────────── */
import React from "react";
import { useHistory } from "react-router-dom";
import { GiValve } from "react-icons/gi";
import SolenoidBoxComponent from "../sensor/SolenoidBox";
import SplashScreen from "../utils/SplashScreen";
import { useSensorList } from "./dashV3.data";
import {
  PageContainer, ContentContainer, OuterBox, SensorType, DeviceGroup,
  PageHeader, BackBtn, HeaderTitle, HeaderCount, Msg,
} from "./dashV3.styles";

export default function ValvesPageV3() {
  const history = useHistory();
  const { loading, valves } = useSensorList();

  if (loading) return <SplashScreen />;

  return (
    <PageContainer>
      <PageHeader>
        <BackBtn onClick={() => history.push("/")}>←</BackBtn>
        <GiValve size={20} color="#237A35" />
        <HeaderTitle>Valves</HeaderTitle>
        <HeaderCount>{valves.length} valves</HeaderCount>
      </PageHeader>

      <ContentContainer>
        <OuterBox>
          <SensorType>Solenoid Valves</SensorType>
          {valves.length === 0 ? (
            <Msg>No valves.</Msg>
          ) : (
            <DeviceGroup>
              {valves.map((v) => (
                <SolenoidBoxComponent key={v.solenoid_id} sensor={v} />
              ))}
            </DeviceGroup>
          )}
        </OuterBox>
      </ContentContainer>
    </PageContainer>
  );
}
